import React from 'react'


export function getData(array, id, key) {
  let res;
  array && array.forEach(one => {
    if (one['id'] === id) res = key ? one['fields'][key] : one['fields']
  });
  return res;
}




export const filterTags = (tags, what, productId, value) => {
  //filter by type
  let a = tags.filter(oneTag => oneTag['fields']['group'].includes(what));
  //filter by product
  if (a.length) a = productId ? a.filter(oneTag => oneTag['fields'][what] && oneTag['fields'][what].includes(productId)) : a;
  if (a.length) a = value ? a.filter(oneTag => oneTag['fields']['id'] === value) : a;
  return a
}

